module.exports = __webpack_public_path__ + "img/ico_programasSocialesRecurso.5716a2c7.png";